import { ELOQUENT } from '../config/constants';

export function getAllRooms(query) {
    return ELOQUENT.Room.getAll(query);
}

export function createRoom(data) {
    return ELOQUENT.Room.createOne(data);
}

export function deleteRoom(id) {
    return ELOQUENT.Room.deleteOne(id);
}

export function updateRoom(id, data) {
    return ELOQUENT.Room.updateOne(id, data);
}

export function getOneRoom(id) {
    return ELOQUENT.Room.getOne(id);
}
